import { useQuery } from 'react-query';

import { getStoredFilterBulkAssignOrRemoveTags as queryFn } from 'api/endPoints/getStoredFilterBulkAssignOrRemoveTags';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetStoredFilterBulkAssignOrRemoveTags = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys]>({
        queryKey: ['getStoredFilterBulkAssignOrRemoveTags'],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.contractId),
    });
};

export interface QueryParams {
    contractId?: number;
}

export interface QueryResponse {
    info: IToolTip;
    tagAssignRule: {
        lastRunActivities: number;
        id: number;
        ruleRank: number;
        appliedFilter: string;
        LastRunActivities: number;
        updatedBy: string;
        updatedByName: string;
        lastUpdate: number;
        assignee: string;
        assigneeName: string;
    }[];
}
